import React from "react"
import cx from "classnames"
import {Popover} from "partials/Popover"
import {Icon} from "partials/Icon"
import {Escapable} from "partials/Escapable"
import {T, BoundComponent} from "utils/react"

export default class Field extends BoundComponent {
  state = {showError: true}
  componentDidUpdate(oldProps) {
    if (oldProps.error !== this.props.error) {
      this.setState({showError: true})
    }
  }
  onChange(value) {
    this.props.onChange(this.props.name, value)
  }
  hideError() {
    this.setState({showError: false})
  }
  renderError() {
    const {error} = this.props

    return (
      <Escapable escape={this.hideError}>
        <Icon theme="warning" icon="warning" /> {error}
      </Escapable>
    )
  }
  renderPopover() {
    const {showError} = this.state
    const {noError, error} = this.props

    return (
      <Popover
        isOpen={Boolean(error) && !noError && showError}
        render={this.renderError}
        placement="top-start"
        className="relative"
      />
    )
  }
  render() {
    /* eslint no-unused-vars: 0 */
    const {Input, inputRef, className, inputProps, noError, ...props} = this.props

    return (
      <div className={cx(className)}>
        {this.renderPopover()}
        <Input {...props} {...inputProps} ref={inputRef} onChange={this.onChange} />
      </div>
    )
  }
}

Field.defaultProps = {
  value: null,
}

Field.propTypes = {
  name: T.string.isRequired,
  value: T.any,
  Input: T.component.isRequired,
  inputRef: T.any,
  noError: T.bool,
  className: T.string,
  error: T.string,
  inputProps: T.object,
  onChange: T.func.isRequired,
}
